module.exports = __webpack_public_path__ + "img/lift_fingerprint_splash.ec49437b.jpg";